export enum SA_NAVIGATION {
    /**
     * @value Social Advocacy
     */
    DASHBOARD_ICON_TOOLTIP = 'FRONT.SOCIAL_ADVOCACY.DASHBOARD_ICON_TOOLTIP',
    /**
     * @value Programs
     */
    PROGRAMS = 'ADMIN.NAV.SOCIAL_ADVOCACY.PROGRAMS',
    /**
     * @value Social Advocacy
     */
    SOCIAL_ADVOCACY = 'ADMIN.NAV.SOCIAL_ADVOCACY',
    /**
     * @value Social networks
     */
    SOCIAL_NETWORKS = 'ADMIN.NAV.SOCIAL_ADVOCACY.SOCIAL_NETWORKS',
}
